.ca{border:1px solid #ddd;}